import React, { useState } from "react";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = ({ children }) => {
  return <span style={{ marginLeft: "0.6rem" }}>{children}</span>;
};


const Header = ({ headers, onSorting, ...rest }) => {
  const [sortingField, setSortingField] = useState("");
  const [sortingOrder, setSortingOrder] = useState("asc");

  const onSortingChange = (field) => {
    const order =
      field === sortingField && sortingOrder === "asc" ? "desc" : "asc";

    setSortingField(field);
    setSortingOrder(order);
    onSorting(field, order);
  };

  return (
    <thead {...rest}>
      <tr>
        {headers.map(({ name, field, sortable }) => (
          <th
            key={name}
            onClick={() => (sortable ? onSortingChange(field) : null)}
          >
            {name}

            {sortingField && sortingField === field && (
              <Icon>
                {sortingOrder === "asc" ? (
                  <i className="bx bx-sort-down"></i>
                ) : (
                  <i className="bx bx-sort-up"></i>
                )}
              </Icon>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default Header;
